namespace $ {

	export function $shm_dashboard_admin_user_dashboards_follower_left(
		translation: number, origin: number, width: number, viewport: number,
	) {
		return Math.max( 0, Math.min( translation + origin, viewport - width ) ) - origin
	}

}
